const stripWww = (host: string) => host.replace(/^www\./i, '');

/**
 * HTTP adreslerini HTTPS yaparak "Güvenli değil" / karma içerik uyarısını önler.
 * Kendi sitemize ait görseller (www'lu/www'suz fark etmeksizin) göreli yola çevrilir;
 * böylece görsel hangi adresten yüklendiyse yüklensin her iki adreste de açılır.
 */
export function ensureHttps(url: string | undefined | null): string {
  if (!url || typeof url !== 'string') return '';

  if (/^https?:\/\//i.test(url) && typeof window !== 'undefined') {
    try {
      const parsed = new URL(url);
      if (stripWww(parsed.hostname) === stripWww(window.location.hostname)) {
        return parsed.pathname + parsed.search + parsed.hash;
      }
    } catch {
      /* geçersiz URL: aşağıdaki kurala düş */
    }
  }

  if (url.startsWith('http://')) return url.replace('http://', 'https://');
  return url;
}
